import React from 'react'
import { FormattedMessage, AppId } from 'base-app'
import {
    ACTION_CHOOSE
} from '../actions/Insurance'
import {
    ACTION_TOGGLETNDS, ACTION_IS_CAl_FEE,ACTION_UPDATE_ACTIVE_STEP,ACTION_IS_LOADING
} from '../actions/Insurance'
import { HttpClient } from 'base-app'
import * as buyInsuranceMoto from "../../configs/constants/BuyInsurance"

const initialState = {
    activeStep:0,
    StepByStep:
        [
            <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.VehicleInfo`} />,
            <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.InsuranceContent`} />,
            <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.OwnAcctInfo`} />,
            <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.Payment4`} />,
            <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.Complete`} />
        ],
    isLoading: false,
    isCalFee: false,


    Step1: {
        loaiXe:
            [
                { value: 'Trên 50cc', label: 'Trên 50cc' },
                { value: 'Xe 3 bánhh lớn hơn cc', label: 'Từ 50 cc trở xuống' },
                { value: 'Xe mô tô 3 bánh', label: 'Xe mô tô 3 bánh' },
            ]
    },
    Step2: {
        toggleTNDS: true
    },
    Step3:
    {


        loaiGiayTo: [
            {
                value: buyInsuranceMoto.ID_TYPE_CMND,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDCMND`} />
            },
            {
                value: buyInsuranceMoto.ID_TYPE_CCCD,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDCCCD`} />
            },
            {
                value: buyInsuranceMoto.ID_TYPE_HOCHIEU,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDHC`} />
            },
            {
                value: buyInsuranceMoto.ID_TYPE_MST,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDMST`} />
            }

        ],
        gender: [
            {
                value: 'MALE',
                label: 'Nam',
            },
            {
                value: 'FEMALE',
                label: 'Nữ',
            },
            {
                value: 'OTHER',
                label: 'Khác',
            },
        ],
    },


    Step4: {
        togleNGCNBH: false
    },
    "": "Không xuất hóa đơn",
    "OwnerInvoice": "Xuất hóa đơn cho Chủ tài sản",
    "OtherPersInvoice": "Xuất hóa đơn cho Cá nhân khác",
    "OtherCoprInvoice": "Xuất hóa đơn cho Tổ chức/Doanh nghiệp khác",
    Step5: {
        loaiHoaDon: [

            {
                value: "NoInvoice",
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.NoInvoice`} />
            },

            {
                value: "OwnerInvoice",
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.OwnerInvoice`} />
            },
            //{value:"", label:'Xuất hóa đơn cho chủ tài sản'},

            {
                value: "OtherPersInvoice",
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.OtherPersInvoice`} />
            },
            {
                value: "OtherCoprInvoice",
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.OtherCoprInvoice`} />
            },
        ],
        loaiGiayTo: [
            {
                value: buyInsuranceMoto.ID_TYPE_CMND,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDCMND`} />
            },
            {
                value: buyInsuranceMoto.ID_TYPE_CCCD,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDCCCD`} />
            },
            {
                value: buyInsuranceMoto.ID_TYPE_HOCHIEU,
                label: <FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.IDHC`} />
            },
        ],
        cities: []
    }
}
const Insurance = (state = initialState, action) => {

    switch (action.type) {
        case "RESET":
            return initialState
        case ACTION_IS_CAl_FEE:
            return {
                ...state,
                isCalFee: action.payload
            }
            case ACTION_UPDATE_ACTIVE_STEP:
            return {
                ...state,
                activeStep: action.payload

            }
            case ACTION_IS_LOADING:
                return {
                    ...state,
                    isLoading: action.payload
    
                }
            
     
        default:
            return state
    }
}
export default Insurance
